export default "__VITE_ASSET__CvY99J3H__"